






import { Vue, Component, Model, Emit, Prop } from "vue-property-decorator";

@Component
export default class AlertSuccess extends Vue {
  @Model("input", { type: Boolean, required: true })
  show!: boolean;

  @Emit("input")
  emitClose() {
    return false;
  }

  @Prop({
    type: String,
    default: "Thành công"
  })
  message!: string;
}
